var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import { getApiClient } from "../../services/AxiosClients";
import PersonInfoDomainService from "../Domain/PersonInfo/PersonInfo.service";
const baseURL = "/aviso/person";
const advisorURL = "/aviso/advisor";
let _me;
export default class PersonService {
    static peopleFromAffiliationIds(affiliationIds) {
        return FetchService.postSingleResponse(baseURL + "/peopleFromAffiliationIds", { affiliationIds });
    }
    static getPersonWithAlertRecipients(affiliationId) {
        return FetchService.get("/aviso/advisor/getPerson", { affiliationId });
    }
    static getPeopleByPersonId(personId) {
        return FetchService.getSingleResponse(baseURL + "/peopleFromPersonId", {
            personId,
        });
    }
    static simpleSearch(query = "", max = 10, offset = 0) {
        return FetchService.getSingleResponse(baseURL + "/simpleSearch", {
            query,
            max,
            offset,
        });
    }
    static simpleSearchWithPersonTypes(query = "", personTypeInternalNames = [], max = 10, offset = 0) {
        return FetchService.getSingleResponse(baseURL + "/search", {
            query,
            personTypeInternalNames,
            max,
            offset,
        });
    }
    static searchPeople({ ids, personTypeInternalNames, includeRoleIds, excludePersonIds, query, } = {}, { max, offset, } = {}) {
        return FetchService.getSingleResponse(baseURL + "/search", {
            ids,
            personTypeInternalNames,
            includeRoleIds,
            excludePersonIds,
            query,
            max,
            offset,
        });
    }
    /**
     * Returns every active non-system staff user in the system
     */
    static searchEnabledNonStudent(search = "") {
        return FetchService.getSingleResponse(baseURL + "/searchEnabledNonStudent", { search });
    }
    /**
     * Returns every staff user in the system
     */
    static searchStaff(search = "") {
        return FetchService.getSingleResponse(baseURL + "/listStaff", {
            q: search,
        });
    }
    static searchMessageRecipients(term, virtualizedAppName) {
        return FetchService.getSingleResponse(baseURL + "/searchMessageRecipients", { term, virtualizedAppName });
    }
    static search(query = "", config = {}) {
        const defaultConfig = {
            onlyStudents: false,
            max: 10,
            offset: 0,
            includePeopleWithNoRoles: false,
        };
        const safeConfig = Object.assign(Object.assign({}, defaultConfig), config);
        return FetchService.get(baseURL + "/listAsJson", {
            query,
            includePeopleWithNoRoles: safeConfig.includePeopleWithNoRoles,
            isStudent: safeConfig.onlyStudents,
            max: safeConfig.max,
            offset: safeConfig.offset,
        });
    }
    // A PersonFulLDTO is also returned on the person attribute from this endpoint, but this will be removed once the
    // student page is cut over to React.  It should not be used.  The @deprecated flag wasn't giving appropriate warnings,
    // so I just did not include it in the type to discourage its use.
    // For now this attribute is used in AdvisorStudentsProfileTab.jsx because the canUnsubscribeCoach attribute is not
    // correctly set on the personDto returned by getPerson.   It is only correctly set in the person returned by this method.
    static getPersonProfile(affiliationId) {
        return FetchService.get(advisorURL + "/getPersonProfile", {
            affiliationId,
        });
    }
    static getPersonSubscriptionStatus(affiliationId) {
        return FetchService.get(advisorURL + "/getPersonSubscriptionStatus", {
            affiliationId,
        });
    }
    static unsubscribe(affiliationId) {
        return FetchService.postSingleResponse(advisorURL + "/unsubscribeFromStudent", {
            affiliationId,
        });
    }
    static subscribe(affiliationId) {
        return FetchService.postSingleResponse(advisorURL + "/subscribeToStudent", {
            affiliationId,
        });
    }
    static amIAdministrator() {
        return FetchService.getSingleResponse(baseURL + "/amIAdministrator");
    }
    static amIAdjunct() {
        return FetchService.getSingleResponse(baseURL + "/amIAdjunct");
    }
    static canIText() {
        return FetchService.getSingleResponse(baseURL + "/canIText");
    }
    static me() {
        if (!_me) {
            _me = FetchService.getSingleResponse(baseURL + "/me");
        }
        return _me;
    }
    static loadCurrentPersonInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield getApiClient().get("/me", {});
            return PersonInfoDomainService.fromJSON(response.data);
        });
    }
    static searchWithMeetingAvailability({ ids, personTypeInternalNames, includeRoleIds, excludePersonIds, query, } = {}, { max, offset, } = {}) {
        return FetchService.getSingleResponse(baseURL + "/searchWithMeetingAvailability", {
            ids,
            personTypeInternalNames,
            includeRoleIds,
            excludePersonIds,
            query,
            max,
            offset,
        });
    }
    static getFullSanitizedByAffiliationId(affiliationId) {
        return FetchService.getSingleResponse(baseURL + "/getFullSanitizedByAffiliationId", {
            affiliationId,
        });
    }
}
